import { STORE_MENU_LIST, REDUCE_MENU_LIST, CLEAR_MENU_LIST } from "../actions";
import { CHECK_AVAILAIBILITY } from "../../utils/CommonFunctions";
import { SESSION_TIMINGS } from "../../utils/Constants";

export default function menuList(state = {}, action) {
  const cafePass = action.cafePass || {};
  const preOrderData = action.storePreOrderData || {};
  const sessionsData = action.storeSessionsData || {};
  const getFromStore = false;
  const getPreOrderDataFromStore = false;
  const getSessionsDataFromStore = false;
  switch (action.type) {
    case STORE_MENU_LIST:
      return action.payload;
    case CLEAR_MENU_LIST:
      return {};
    case REDUCE_MENU_LIST:
      let newData = {};
      let realTimeSession = "";
      let {
        immutableMenuList: data,
        immutableSubMenu,
        selectedDate,
        currentSession,
        filters,
        searchText,
        searchId,
        servingTime,
        restaurantIsAlive,
        isBuffet,
        allergens = []
      } = action.payload;
      searchText = searchText.toLowerCase();
      if (searchText) {
        searchId = {
          label: "",
          items: []
        };
      }

      let needToCheck = true;
      let isPreOrder = Object.keys(preOrderData).length ? true : false;
      
      if (
        !CHECK_AVAILAIBILITY(
          servingTime,
          cafePass,
          getFromStore,
          preOrderData,
          getPreOrderDataFromStore,
          sessionsData,
          getSessionsDataFromStore
        )
      ) {
        needToCheck = false;
      }

      if (needToCheck) {
        if (selectedDate !== "") {
          let currentDate = new Date();
          selectedDate = selectedDate.split("-");
          if (selectedDate[0] != currentDate.getDate() && !isPreOrder) {
            needToCheck = false;
          }
        }

        if (needToCheck && !isPreOrder) {
          if (!isBuffet && !restaurantIsAlive) {
            needToCheck = false;
          }
        }
      }

      // if (needToCheck) {
      //   if (!CHECK_AVAILAIBILITY(SESSION_TIMINGS[currentSession])) {
      //     needToCheck = false;
      //   }
      // }

      // let sessions = Object.keys(SESSION_TIMINGS);
      let sessions = Object.keys(sessionsData);
      for (let i = 0; i < sessions.length; i++) {
        if (
          CHECK_AVAILAIBILITY(
            // SESSION_TIMINGS[sessions[i]],
            sessionsData[sessions[i]],
            cafePass,
            getFromStore,
            preOrderData,
            getPreOrderDataFromStore,
            sessionsData,
            getSessionsDataFromStore
          )
        ) {
          realTimeSession = sessions[i];
          break;
        }
      }

      if (realTimeSession === "") {
        realTimeSession = sessions[0];
        needToCheck = false;
      }

      if (filters.length === 0) {
        filters = ["V", "E", "N"];
      }

      let itemsArray = Object.keys(data);

      let searchedItems = { available: [], unavailable: [] };
      let searchedItemsIndexes = {};

      newData = itemsArray.reduce((accumulator, value) => {
        let item = data[value];
        let addedToSearchItems = false;
        let addedAvailableItem = false;
        let isMatch = false;
        let sessionsList = item["sessions"] || [];
        let categories = [...(item["listofcategories"] || [])];

        if (searchText !== "") {
          if (item["foodname"].toLowerCase().indexOf(searchText) !== -1) {
            isMatch = true;
          }
        }

        if (searchId.items.length && !searchText) {
          if (searchId.items.includes(item.foodid)) {
            isMatch = true;
          }
        }
        let {
          extras: { nutritionInfo: { allergens: itemAllergens = [] } = {} } = {}
        } = item;
        let allergensCheck = true;
        if (itemAllergens.length !== 0) {
          for (let i = 0; i < itemAllergens.length; i++) {
            if (allergens.indexOf(itemAllergens[i]) === -1) {
              allergensCheck = false;
              break;
            }
          }
        }
        sessionsList = sessionsList.filter(session => {
          return sessions.includes(session);
        });

        if (
          (!sessionsList || (sessionsList && sessionsList.length === 0)) &&
          !isPreOrder
        ) {
          sessionsList = [realTimeSession];
        }

        sessionsList &&
          sessionsList.map(session => {
            let isAvailable = true;
            if (!accumulator.hasOwnProperty(session)) {
              accumulator[session] = {};
            }

            categories.map(category => {
              if (!accumulator[session].hasOwnProperty(category)) {
                accumulator[session][category] = {
                  available: [],
                  unavailable: []
                };
              }

              if (allergensCheck && filters.includes(item["vegflag"])) {
                if (!item["servingFlag"]) {
                  isAvailable = false;
                }

                if (item["outofstock"]) {
                  isAvailable = false;
                }

                if (!needToCheck) {
                  isAvailable = false;
                }

                if (session !== realTimeSession && !isPreOrder) {
                  isAvailable = false;
                }

                item["submenu"].map(subCategory => {
                  if (
                    immutableSubMenu.attributes[subCategory].outOfStockStatus
                  ) {
                    isAvailable = false;
                  }
                });

                if (isPreOrder && !sessions.includes(session)) {
                  isAvailable = false;
                }

                let foodObj = {
                  foodid: item["foodid"],
                  shouldDisable: !isAvailable
                };

                const searchItemsCondition = isMatch && !addedToSearchItems;
                if (isAvailable) {
                  accumulator[session][category].available.push(foodObj);

                  let isFoodItemAlreadyAdded =
                    typeof searchedItemsIndexes[foodObj["foodid"]] !==
                    "undefined";
                  if (
                    searchItemsCondition ||
                    (isMatch && isFoodItemAlreadyAdded)
                  ) {
                    searchedItems.available.push(foodObj);
                    addedToSearchItems = true;

                    if (!addedAvailableItem) {
                      if (isFoodItemAlreadyAdded) {
                        let index = searchedItemsIndexes[foodObj["foodid"]] - 1;
                        searchedItems.unavailable.splice(index, 1);
                        delete searchedItemsIndexes[foodObj["foodid"]];
                        addedAvailableItem = true;
                      }
                    }
                  }
                } else {
                  accumulator[session][category].unavailable.push(foodObj);

                  if (searchItemsCondition) {
                    let index = searchedItems.unavailable.push(foodObj);
                    searchedItemsIndexes[foodObj["foodid"]] = index;
                    addedToSearchItems = true;
                  }
                }
              }
            });
          });

        return accumulator;
      }, {});

      searchedItems = [
        ...searchedItems.available,
        ...searchedItems.unavailable
      ];

      let notAvailableKey = "Unavailable Items";
      newData = Object.keys(newData).reduce((accumulator, session) => {
        let categories = Object.keys(newData[session]);

        let categoriesObj = categories.reduce((accumulator, category) => {
          accumulator[category] = [...newData[session][category].available];

          if (newData[session][category].unavailable.length !== 0) {
            if (accumulator[notAvailableKey] === undefined) {
              accumulator[notAvailableKey] = {};
            }
            accumulator[notAvailableKey][category] = [
              ...newData[session][category].unavailable
            ];
          }

          return accumulator;
        }, {});

        if (searchText !== "" || (searchId.label && searchedItems.length)) {
          categoriesObj[
            `${searchId.label || "Searched Items"}`
          ] = searchedItems;
        }

        accumulator[session] = categoriesObj;

        return accumulator;
      }, {});

      const preOrderSession = preOrderData.session || "";
      if (isPreOrder) {
        if (
          Object.keys(newData).length === 0 ||
          !newData.hasOwnProperty(preOrderSession)
        ) {
          return {
            [preOrderSession]: {}
          };
        }
      }
      return newData;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/menuList.js